import React from 'react';
import connect from '@src/js/separate-logic/connect';
import type { AddonWhitelist } from '@tencent/td-addon-sdk-docs';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import AddonLoading from './addon-loading';
import AddonScaleView from './addon-scale-view/addon-scale-view';
import RenderIframePresenter from './render-iframe-presenter';
import RenderIframeModel from './render-iframe-model';
import { getSlideIndex, isInMiniAppRenderWhitelist } from './utils';
import AddonReport from '@src/slide/application/service/addon/addon-report';

interface IRenderIframeProps {
    size: any,
    addon: any,
    component: any,
    isSelected: boolean,
    isPlayState: boolean,
    loadCover: boolean,
    inCurrentSlide: boolean,
    needEvent: boolean,
    mobileEditMode: any,
    setRef: (name: string, ref: any) => void,
    pointerEvents: any,
    handleTouchStartNotEditMode: (event) => void,
    iframeLoadingEnd: (e) => void,
    iframeSrc: string,
    snapshotUrl: string | null,
    addonName: string | null;
    addonIcon: string | null;
    miniAppRenderWhitelist: AddonWhitelist[];
    isVideoType: boolean,
}
export class RenderIframe extends React.Component<IRenderIframeProps> {
    public static defaultProps = {
        setRef: () => {},
    };

    public componentDidMount(): void {
        // iframe 元素在 canvas 画布上选中才会进行渲染，所以在 componentDidMounts 时进行点击上报
        if (this.props.isSelected) {
            // 元素被选中，上报点击事件
            AddonReport.reportAddonIframeClick(this.props.addon?.iframeId);
        }
    }

    public render() {
        const { size, addon, isSelected, isPlayState, loadCover, inCurrentSlide, needEvent,
            setRef, handleTouchStartNotEditMode, iframeLoadingEnd, component, iframeSrc,
            snapshotUrl, addonName, addonIcon, miniAppRenderWhitelist, isVideoType,
        } = this.props;
        const isInMiniWhitelist = isInMiniAppRenderWhitelist(addon.embedUrl, miniAppRenderWhitelist);
        const { width, height } = size;
        const mobileEditMode = this.getMobileEditMode();
        const pointerEvents = this.getPointerEvents(
            needEvent,
            isSelected,
            mobileEditMode,
        );
        // 是否需要加载插件 iframe
        const iframeExist = this.showIframe(inCurrentSlide, isPlayState, mobileEditMode, isInMiniWhitelist);
        return (
            <div
                style={{
                    width, height,
                    position: 'absolute', top: 0, left: 0,
                    // eslint-disable-next-line no-nested-ternary
                    pointerEvents,
                }}
                className={'iframe-wrapper'}
                ref={ref => setRef('iframeWrapperRef', ref)}
                onTouchStart={browser.isMobile ? handleTouchStartNotEditMode : undefined}
            >
                {iframeExist ? <iframe id={addon.iframeId}
                    src={iframeSrc}
                    onLoad={iframeLoadingEnd}
                    allowFullScreen
                    style={{
                        width, height, backgroundColor: 'white',
                        border: '1px solid rgba(0, 0, 0, 0.08)',
                    }}
                    sandbox="allow-scripts allow-same-origin allow-popups allow-orientation-lock"
                /> : null}
                <AddonScaleView
                    ref={ref => setRef('scaleView', ref)}
                    size={size}
                    src={addon.originUrl}
                    snapshotUrl={snapshotUrl}
                    addonName={addonName}
                    addonIcon={addonIcon}
                    isInIframeRenderWhiteList={isInMiniWhitelist}
                    miniAppRenderWhitelist={miniAppRenderWhitelist}
                    scaleViewHidden={iframeExist}
                    mobileEditMode={mobileEditMode} // 根据editMode 决定占位文字
                    index={isPlayState ? undefined : getSlideIndex(component)}
                    isPlayState={isPlayState}
                    isVideoType={isVideoType}
                    addon={addon}
                />
                <AddonLoading
                    loadCover={loadCover}
                />
            </div>
        );
    }

    private getMobileEditMode = () => (this.props.mobileEditMode ? this.props.mobileEditMode() === false : false);

    private getPointerEvents = (needEvent, isSelected, mobileEditMode) => {
        const pointerEvents = (needEvent && isSelected) || mobileEditMode ? 'auto' : 'none';
        // eslint-disable-next-line no-nested-ternary
        return browser.isMobile ? 'auto' : this.props.pointerEvents ? this.props.pointerEvents : pointerEvents;
    };

    // 判断是否需要加载 iframe
    private showIframe = (inCurrentSlide, isPlayState, mobileEditMode, isInMiniWhitelist) => {
        // 常规 iframe 加载场景：要么是pc端 要么是非小程序播放态 要么是移动端编辑态
        const iframeRenderEnv = (!browser.isMobile || isPlayState || (browser.isMobile && mobileEditMode));
        // 在小程序当前页，常规加载场景，只有白名单可以加载
        if (browser.isMiniProgram) {
            return inCurrentSlide && iframeRenderEnv && isInMiniWhitelist;
        }
        // 否则在当前页，常规加载场景均可加载
        return inCurrentSlide && iframeRenderEnv;
    };
}

export default connect(
    RenderIframePresenter,
    RenderIframeModel,
    RenderIframe,
);
